/**
 * @generated SignedSource<<f8fb1c6f46adce052d2e23c1994fb5fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetProjectSlackChannelInput = {
  projectId?: string | null;
  channelId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type SetProjectSlackChannelMutation$variables = {
  input: SetProjectSlackChannelInput;
};
export type SetProjectSlackChannelMutation$data = {
  readonly setProjectSlackChannel: {
    readonly project: {
      readonly slackChannelId: string | null;
    } | null;
  } | null;
};
export type SetProjectSlackChannelMutation = {
  variables: SetProjectSlackChannelMutation$variables;
  response: SetProjectSlackChannelMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackChannelId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetProjectSlackChannelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetProjectSlackChannelPayload",
        "kind": "LinkedField",
        "name": "setProjectSlackChannel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetProjectSlackChannelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetProjectSlackChannelPayload",
        "kind": "LinkedField",
        "name": "setProjectSlackChannel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3facfd01dfcdabedf2ec6565e36f6966",
    "id": null,
    "metadata": {},
    "name": "SetProjectSlackChannelMutation",
    "operationKind": "mutation",
    "text": "mutation SetProjectSlackChannelMutation(\n  $input: SetProjectSlackChannelInput!\n) {\n  setProjectSlackChannel(input: $input) {\n    project {\n      slackChannelId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "83561d5db6fce9fd62943be191593e33";

export default node;
